'use client';

import { datadogRum } from '@datadog/browser-rum';

datadogRum.init({
  applicationId: '247b2ecf-f526-47ba-934a-d1c1c8246d21',
  clientToken: 'pubc96a8294ea2dee654981a6bf13b97de4',
  site: 'datadoghq.com',
  service: 'mtlr-scm-prod',
  env: 'prod',

  // Specify a version number to identify the deployed version of your application in Datadog
  // version: '1.0.0',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input',
  //   plugins: [reactPlugin({ router: false })],
  allowedTracingUrls: [
    {
      match: 'https://dev-api.metalearner.ai',
      propagatorTypes: ['tracecontext'],
    },
    {
      match: 'https://scm-api.metalearner.ai',
      propagatorTypes: ['tracecontext'],
    },
    {
      match: 'https://core.metalearner.ai',
      propagatorTypes: ['tracecontext'],
    },
  ],
});

export default function DatadogInit() {
  // Render nothing - this component is only included so that the init code
  // above will run client-side
  return null;
}
